export const resizeHeader = () => {
  const headerContainer = document.querySelector<HTMLElement>('.header__container');
  if (headerContainer) {
    document.querySelector<HTMLElement>('.header')!.style.height = `${headerContainer.offsetHeight}px`;
  }
};
